<script setup>
import { computed } from 'vue'
import { date } from '@bignerve/ui-utils'
import { cn } from '/app/lib/utils'
import { track } from '/app/utils/analytics'
import NIcon from '/app/components/NIcon.vue';

const props = defineProps({
    detail: {
        type: Object,
    },
    simple: {
        type: Boolean,
        default: false,
    },
})

const computedClass = computed(() => {
    const role = props.detail.targetGameDash.split(',')[0]
    return `is-${role}`
})

function onNotificationClick() {
    track('Game Dash Notification Clicked', {
        notification_type: 'helpful-tip',
        role: props.detail.targetGameDash?.split(',')[0],
        title: props.detail.title,
    })

    props.detail.action?.()
}
</script>

<template>
    <div :class="cn('game-dash-list-item cursor-pointer text-left text-dust-700', computedClass)" data-heap-id="gamedash-notification" data-heap-notification-type="helpful-tip">
        <div class="game-dash-list-item__point game-dash-list-item__point--icon">
            <NIcon :as="detail.icon" class="text-lg" />
        </div>
        <div class="game-dash-list-item__content">
            <span v-if="detail.title" class="game-dash-list-item__text font-semibold mr-1 text-dust-800">
                {{ detail.title }}
            </span>
            <component
                v-if="detail.actionTitle"
                v-html="detail.actionTitle"
                :is="detail.route ? 'router-link' : 'button'"
                :to="detail.route"
                class="game-dash-list-item__text text-left hover:text-nerve text-dust no-underline"
                @click="onNotificationClick"
            />
            <div v-if="!simple" class="game-dash-list-item__meta my-0">{{ date(detail.issuedAt, 'human') }}</div>
        </div>
    </div>
</template>